import { render, staticRenderFns } from "./edit-common-dishe-form.vue?vue&type=template&id=6cb9f82b&scoped=true&"
import script from "./edit-common-dishe-form.vue?vue&type=script&lang=js&"
export * from "./edit-common-dishe-form.vue?vue&type=script&lang=js&"
import style0 from "./edit-common-dishe-form.vue?vue&type=style&index=0&id=6cb9f82b&lang=less&scoped=true&"
import style1 from "./edit-common-dishe-form.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb9f82b",
  null
  
)

export default component.exports